// src/theme/components/buttonStyles.js
const buttonStyles = (theme) => {
  return {
    // Add this return statement
    MuiButton: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: "contained", size: "large" },
              style: {
                fontWeight: "bold",
                // Adjust padding for better touch targets on mobile
                padding: {
                  xs: theme.spacing(1.5, 2), // More vertical padding but less horizontal on small screens
                  sm: theme.spacing(1.5, 3),
                  md: theme.spacing(2, 4), // Original size for desktop
                },
                minWidth: {
                  xs: 64, // Smaller minimum width on mobile
                  sm: 88,
                  md: 96, // Larger on desktop
                },
                fontSize: {
                  xs: "0.875rem", // Slightly smaller font on mobile
                  sm: "0.9375rem",
                  md: "1rem", // Normal font size on desktop
                },
              },
            },
          ],
        },
      },
      defaultProps: {
        // Ensure buttons meet touch target size recommendations
        disableElevation: true, // Flat design often works better across devices
      },
    },
  }; // Close the return statement
};

export default buttonStyles;
